/**
 * Fire-and-forget email to super-admin after half-claw auto-confirm (Edge + Brevo).
 * @see docs/APP_UI_SPEC.md — D4
 */

/**
 * @param {import('@supabase/supabase-js').SupabaseClient} supabase
 * @param {object} payload — same shape as `attemptAutoConfirm` → `notifyPayload`
 */
export async function notifyInboxAutoConfirmByEmail(supabase, payload) {
  try {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) {
      console.warn('notifyInboxAutoConfirmByEmail: no session; skip notify');
      return;
    }
    const { error } = await supabase.functions.invoke('inbox-auto-confirm-notify', {
      body: payload,
      headers: {
        Authorization: `Bearer ${session.access_token}`,
      },
    });
    if (error) {
      console.warn('notifyInboxAutoConfirmByEmail: invoke failed', error);
    }
  } catch (e) {
    console.warn('notifyInboxAutoConfirmByEmail', e);
  }
}
